<template>
  <div class="resource-credentials">
    <div class="header">
      <label class="resource-title"> {{ $t('newProject.resources.credentials') }}</label>
      <v-icon v-if="canEdit" class="resource-edit-button" @click="toggleShowEditPopup">edit</v-icon>
    </div>
    <div class="columns" v-if="resource.credentials && resource.credentials.length">
      <resource-logins :items="resource.credentials" />
      <resource-passwords :items="resource.credentials" />
    </div>
    <edit-credentials-popup
      v-if="canEdit"
      :visiblePopup="showEditPopup"
      :resource="resource"
      :resourceNumber="resourceNumber"
      @close="toggleShowEditPopup"
      @save="saveResourceCredentials"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { userRoleGroups } from '@/constants/auth';
import EditCredentialsPopup from '@/components/popup/EditCredentialsPopup.vue';

import ResourceLogins from './ResourceLogins.vue';
import ResourcePasswords from './ResourcePasswords.vue';

export default {
  name: 'ResourceCredentials',
  components: {
    ResourcePasswords,
    ResourceLogins,
    EditCredentialsPopup,
  },
  props: {
    resource: {
      type: Object,
      required: true,
    },
    resourceNumber: {
      type: Number,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showEditPopup: false,
  }),
  computed: {
    ...mapGetters(['userRoleGroup']),
    canEdit() {
      return this.editable && this.userRoleGroup === userRoleGroups.CISO;
    },
  },
  methods: {
    toggleShowEditPopup() {
      this.showEditPopup = !this.showEditPopup;
    },
    saveResourceCredentials(resource) {
      this.$emit('update', resource);
      this.toggleShowEditPopup();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.resource-credentials {
  padding: rem(8) rem(10);
  border-bottom: solid rem(1) rgba(159, 165, 180, 0.5);

  .columns {
    display: flex;

    .resource-logins {
      flex-basis: rem(254);
    }

    .resource-passwords {
      flex-grow: 1;
    }
  }

  .header {
    display: flex;
    justify-content: space-between;

    .resource-edit-button {
      color: var(--brand-primary);
      border-bottom: rem(1) solid var(--brand-primary);
    }

    .resource-title {
      display: block;
      color: var(--text-tertiary);
      font-size: rem(14);
      letter-spacing: 0;
      line-height: rem(16);
      text-transform: capitalize;
      margin-bottom: rem(5);
      padding: 0 rem(6);
    }
  }
}
</style>
